import temporal from '@pretto/bricks/core/utility/temporal'

import { INDEBTEDNESS_RATE } from '../config/static'

export const monthlyRate = rate => rate / (12 * 100)

export const loanAmount = ({ goodAmount, contribution = 0 }) => goodAmount - contribution

export const payment = ({ loanAmount, rate, duration }) => {
  if (loanAmount === 0 || duration === 0) {
    return 0
  }
  const r = monthlyRate(rate)

  return loanAmount * (r / (1 - (1 + r) ** (-duration * 12)))
}

export const creditCost = ({ payment, duration, loanAmount }) => payment * duration * 12 - loanAmount

const DEFAULT_RENEGOTIATION_RESPONSE = { loanAmount: 0, remainingDuration: 0 }
export const renegotiationLoanAmount = ({ payment, rate, signDate, duration, now = temporal() }) => {
  const temporalSignDate = temporal(signDate)
  const monthDiff = now.diff(temporalSignDate, 'month')
  const isAfter = temporalSignDate.isAfter(now)
  const monthlyRemainingDuration = duration * 12 - monthDiff
  const remainingDuration = monthlyRemainingDuration / 12

  if (isAfter || remainingDuration <= 0) {
    return DEFAULT_RENEGOTIATION_RESPONSE
  }

  const loanAmount = capacityLoanAmount({ duration: remainingDuration, payment, rate })

  return { loanAmount, remainingDuration }
}

export const capacityTotalAmount = ({ income, duration }) => income * 12 * duration * INDEBTEDNESS_RATE

export const capacityPayment = ({ income }) => income * INDEBTEDNESS_RATE

export const capacityLoanAmount = ({ duration, payment, rate }) => {
  const r = monthlyRate(rate)

  return payment / (r / (1 - (1 + r) ** (-duration * 12)))
}

export const savings = ({ payment, newPayment, remainingDuration }) => (payment - newPayment) * (remainingDuration * 12)
